import { initialize } from 'launchdarkly-js-client-sdk';
import { recordException } from '../utils/GALogger';

let client;

export async function initFeatureFlagService(clientSideKey) {
  try {
    client = initialize(clientSideKey, { kind: 'user', key: 'anonymous-user-key', name: 'anonymous' });
    await client.waitForInitialization();
  } catch (error) {
    recordException({ description: `FeatureFlagService init error: ${error.message}` });
  }
}

export function featureEnabled(flagName, fallback = false) {
  return client ? client.variation(flagName, fallback) : fallback;
}